export const initialOptions = {
  "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
  // "enable-funding": "venmo",
  "disable-funding": "",
  "buyer-country": "US",
  currency: "USD",
  "data-page-type": "product-details",
  components: "buttons",
  "data-sdk-integration-source": "developer-studio",
};

export const buttonStyle = {
  shape: "rect",
  layout: "horizontal",
  color: "silver",
  label: "paypal",
  height: 45
};
